import axiosInstance from './api_helper';
export const getVfdConfiguration = (pointOfSaleId) => axiosInstance.get(`/api/pos/${pointOfSaleId}/vfd-configuration`);
export const saveVfdConfiguration = (pointOfSaleId, configuration) => axiosInstance.put(`/api/pos/${pointOfSaleId}/vfd-configuration`, configuration);
